import { useEffect } from 'react'
import { useFieldArray, Controller } from 'react-hook-form'
import SuggestionField from '../../contacts/form/SuggestionField'
import { useBienContext } from '../BienContext'
import { useFormContext } from '../SectionForm'

export default ({control, formErrors, apiErrors}) => {
  const { bien } = useBienContext()
  const { setValue, formState } = useFormContext()

  // Utilisation de useFieldArray pour gérer un tableau de propriétaires
  const { fields, append, remove } = useFieldArray({
    control,
    name: "acquereurs"
  })

  useEffect(() => {
    if (!formState.isDirty && bien.acquereurs?.length > 0) {
      setValue("acquereurs", bien.acquereurs.map( c => ({...c, contact_id: c.id })))
    }
  }, [] )

  // Assurons-nous qu'il y a au moins un champ vide si aucun propriétaire n'est défini
  useEffect(() => {
    if (fields.length === 0) {
      append({ contact_id: '' });
    }
  }, [fields.length]);

  // Fonction utilitaire pour obtenir l'erreur combinée (du form ou de l'API)
  const getErrorMessage = (fieldName) => 
    formErrors?.[fieldName]?.message || apiErrors?.[fieldName] || '';

  // Fonction utilitaire pour déterminer si un champ a une erreur
  const hasError = (fieldName) => 
    !!formErrors?.[fieldName] || !!apiErrors?.[fieldName]
     
  return (
    <div className='w-full'>
      {fields.map((values, index) => (
        <div key={values.id} className="mb-4 relative flex justify-end items-center">
          {/* Afficher le bouton de suppression seulement s'il y a plus d'un acquéreur */}
          {fields.length > 1 && (
            <button 
              type="button"
              className="btn btn-circle btn-xs btn-ghost bg-base-200 hover:bg-base-300 mr-4"
              onClick={() => remove(index)}
              title="Supprimer cet acquéreur"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h14" />
              </svg>
            </button>
          )}

          <div className="w-8/9">
            <Controller
              name={`acquereurs.${index}`}
              control={control}
              render={({ field }) => (
                <SuggestionField
                  contactField={field}
                  originalData={values}
                  hasError={hasError(`acquereurs.${index}`)} 
                  errorMessage={getErrorMessage(`acquereurs.${index}`)}
                  label={`Acquéreur ${index + 1}`}
                />
              )}
            />
          </div>
        </div>
      ))}
      
      {/* Bouton pour ajouter un nouveau propriétaire */}
      <div className="flex flex-col space-x-2">
        <button
          type="button"
          className="btn btn-outline new-buyer"
          onClick={() => append({ contact_id: '' })}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Ajouter un acquéreur
        </button>         
      </div>
    </div>
  )
}